// removed by extract-text-webpack-plugin
module.exports = {"flex":"HomePage__flex___3Ehcg","flex-column":"HomePage__flex-column___1jA2W","flex-column-center":"HomePage__flex-column-center___3y_L6","container":"HomePage__container___10tMq","section":"HomePage__section___3MZj6","flex-row":"HomePage__flex-row___1rSd1","flex-row-center":"HomePage__flex-row-center___1HqCa"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Home/components/HomePage/HomePage.scss
// module id = 1250
// module chunks = 8